export default "__VITE_ASSET__vlSRErsr__"